import React from "react";
import { useSelector } from "react-redux";

const Layout = ({ children }) => {
  const access_configuration = useSelector(
    (state) => state.login.access_configuration
  );
  return (
    <div className={`${access_configuration === null && "is-off-background"}`}>
      {children}
    </div>
  );
};

export default Layout;
